import { DealerShareBuilder } from './dealer.share';

export class IcsShareDataBuilder extends DealerShareBuilder {
  /**
   * 
   * @param { object} dealerInfo 经销商信息
   * @param { object }  adviserInfo 顾问信息
   * @param { boolean } dealerHasRtc 店铺是否开通vr带看
   * @param { boolean } saleHasRtc 当前顾问是否开通vr带看
   * @param { object } shareInfo 店铺分享信息
   * @param {  string } channelName 分享渠道
  * @param {  string } shareType 分享方式，vrShareTask 分享待办; '': 展厅分享
   */
  constructor ({ dealerInfo, adviserInfo, dealerHasRtc, saleHasRtc, shareInfo, channelName, shareType = '', path = '' }) {
    super({ dealerInfo, shareInfo });
    this.adviserInfo = adviserInfo;
    this.dealerHasRtc = dealerHasRtc;
    this.saleHasRtc = saleHasRtc;
    this.channelName = channelName;
    this.shareType = shareType;
    this.path = path;
  }
  getPvAreaId () {
    if (this.shareType === 'vrShareTask') {
      return this.channelName === 'weixin' ? 6856151 : 6856152;
    }
    return this.channelName === 'weixin' ? 6854960 : 6854961;
  }
  buildShareData () {
    const adviserInfo = this.adviserInfo;
    const shareInfo = this.shareInfo;
    let title = '';
    if (this.dealerHasRtc) {
      if (this.saleHasRtc) {
        title = `买好车就找我，${adviserInfo.salesName}为您在线VR带看，看车问价一站式服务。`;
      } else {
        title = `买好车就找我，${adviserInfo.salesName}为您看车问价一站式服务。`;
      }
    } else {
      title = `买好车就找我，${adviserInfo.salesName}为您推荐线上逛店。`;
    }
    let imageUrl = adviserInfo.photoUrl;
    if (!adviserInfo.photoUrl && shareInfo && shareInfo.dealerImage) {
      imageUrl = shareInfo && shareInfo.dealerImage;
    }
    let pvAreaId = this.getPvAreaId();
    const pathname = this.path ? this.path : window.location.pathname
    let link = `${window.location.origin}${pathname}?busi=icsShare&pvareaid=${pvAreaId}&salesId=${adviserInfo.salesId}`;
    if (imageUrl) {
      return { title, icon: imageUrl, link };
    } else {
      return { title, link };
    }
  }
}